import * as z from "zod/v4";

export const reorderWorkOrderPriorityFilters = {
  name: "reorderWorkOrderPriorityFilters" as const,
  input: z.object({
    filters: z.array(z.object({ id: z.string(), position: z.number() })),
  }),
  output: z.object({ success: z.boolean() }),
};
